import { Backdrop, CircularProgress } from '@mui/material';

interface LoadingBackdropProps {
  open: boolean;
}

export default function LoadingBackdrop({ open }: LoadingBackdropProps) {
  return (
    <Backdrop
      open={open}
      sx={{
        backgroundColor: 'transparent',
        color: '#5EBEBB',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

